import { DisputeDetailSchema } from "@redotech/redo-model/disputes/dispute-view";
import * as z from "zod/v4";

export const getDispute = {
  name: "getDispute" as const,
  input: z.object({ disputeId: z.string() }),
  output: z.object({ dispute: z.nullable(DisputeDetailSchema) }),
};
